import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Heading, Text } from "@ting/ting-ui-components";
export const Title = ({ title, size, icon }) => {
    const sizes = { small: "p1", medium: "h4", large: "h3" };
    return (_jsxs(Heading, { type: "h3", children: [icon && icon, _jsx(Text, { type: "main", size: sizes[size], fontWeight: "semiBold", children: title })] }));
};
